import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DetailPageLayout, { DetailSection } from '../utils/DetailPageLayout';

function SingleAircraftContent(props) {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const url = `${process.env.REACT_APP_API_BASE_URL}/api/aircraft/${id}`;

  useEffect(() => {
    setIsLoading(true);
    fetch(url)
      .then((res) => res.json())
      .then((data) => setData(data))
      .catch((err) => setHasError(err))
      .finally(() => setIsLoading(false));
  }, [url]);

  if (isLoading) {
    return (
      <>
        <div className="detail-page"><p>Loading...</p></div>
      </>
    );
  }

  if (hasError || !data) {
    return (
      <>
        <div className="detail-page"><p>Could not load this aircraft.</p></div>
      </>
    );
  }

  const meta = [];
  const typeLabel = [data.DocType, data.SubType].filter(Boolean).join(' / ');
  if (typeLabel) meta.push({ label: 'Type', value: typeLabel });
  if (data.Country) meta.push({ label: 'Location', value: data.Country });

  const imgUrl = data.Filename ? `${process.env.REACT_APP_API_BASE_URL}/img/aircraft/${data.Filename}` : null;
  const titleHtml = data.Description || 'Aircraft';

  return (
    <>
      <DetailPageLayout
        eyebrow="Aircraft"
        title={<span dangerouslySetInnerHTML={{ __html: titleHtml }} />}
        meta={meta}
      >
        {imgUrl && (
          <DetailSection title="Image">
            <img src={imgUrl} alt={data.Description || 'Aircraft'} />
          </DetailSection>
        )}

        {data.Notes && (
          <DetailSection title="Notes">
            <p>{data.Notes}</p>
          </DetailSection>
        )}

        {(data.SourceName || data.SourceUrl) && (
          <DetailSection title="Source">
            <p>
              {data.SourceName}
              {data.SourceUrl && (
                <>
                  {data.SourceName ? ' — ' : ''}
                  <a href={data.SourceUrl} target="_blank" rel="noopener noreferrer">{data.SourceUrl}</a>
                </>
              )}
            </p>
          </DetailSection>
        )}
      </DetailPageLayout>
    </>
  );
}

export default SingleAircraftContent;
